import sanityClient from '@sanity/client'

export default sanityClient({
    projectId: "vdhatc5v",
    dataset: "production"
})